// GraficoEstadosPlugin.js
import GraficoEstadosPorcentaje from "./GraficoEstadosPorcentaje.vue";
import GraficoEstadosPorcentajeProperties from "./GraficoEstadosPorcentajeProperties.vue";

const GraficoEstadosPlugin = {
  install(Vue) {
    Vue.component("GraficoEstadosPorcentaje", GraficoEstadosPorcentaje);
    Vue.component("GraficoEstadosPorcentajeProperties", GraficoEstadosPorcentajeProperties);
  },
};

export default GraficoEstadosPlugin;
